module.exports = __webpack_public_path__ + "static/img/awardDetails.a9b07509.png";